
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}><MDXTag name="h1" components={components} props={{"id":"ex-4---custom-hooks"}}>{`Ex. 4 - Custom Hooks`}</MDXTag>
<MDXTag name="h2" components={components} props={{"id":"instructions"}}>{`Instructions`}</MDXTag>
<MDXTag name="p" components={components}>{`Nous allons maintenant créer un Hook spécifique qui aura pour responsabilité de faire une recherche sur l'API.`}</MDXTag>
<MDXTag name="ul" components={components}>
<MDXTag name="li" components={components} parentName="ul">{`Créer un Hook custom `}<MDXTag name="inlineCode" components={components} parentName="li">{`useMovieSearch`}</MDXTag>{` dans `}<MDXTag name="inlineCode" components={components} parentName="li">{`src/containers/MovieDb.js`}</MDXTag></MDXTag>
</MDXTag>
<MDXTag name="p" components={components}>{`Le Hook custom devra permettre de récupérer une liste de films depuis l'API.`}</MDXTag>
<MDXTag name="h3" components={components} props={{"id":"résultat-attendu"}}>{`Résultat attendu`}</MDXTag>
<MDXTag name="p" components={components}>{`L'application fonctionne comme auparavant.`}</MDXTag>
<iframe
  src="https://codesandbox.io/embed/github/smooth-code/react-hooks-workshop/tree/end-exercise-4/?fontsize=14&view=preview"
  style={{
    width: '100%',
    height: 500,
    border: 0,
    borderRadius: 4,
    overflow: 'hidden',
  }}
  sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"
/>
<MDXTag name="h2" components={components} props={{"id":"aide"}}>{`Aide`}</MDXTag>
<MDXTag name="h3" components={components} props={{"id":"appjs"}}>{`App.js`}</MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{"className":"language-js"}}>{`// App.js
import React, { useState } from 'react'
import { Normalize, Grid, Typography } from '@smooth-ui/core-sc'
import SearchInput from './components/SearchInput'
import { useMovieSearch } from './containers/MovieDb'

export default function App() {
  const [query, setQuery] = useState('Lord of the Rings')

  // Utilisation du Hook custom permettant de récupérer la liste de films depuis l’API
  const movies = useMovieSearch(query)

  return (
    <>
      {/* Le composant "Grid" centre dans la page, "py" signifie "padding-top" et "padding-bottom" */}
      <Grid py={200}>
        {/* Injection de normalize.css pour avoir un rendu consistant sur tous les navigateurs */}
        <Normalize />
        {/* "Typography" est un composant avec des variantes de titres prêtes à l'emploi */}
        <Typography variant="display-1">Smooth Movie</Typography>
        {/* Votre composant "SearchInput" */}
        <SearchInput
          value={query}
          onChange={event => setQuery(event.target.value)}
        />
        {/* Affichage de la liste de films */}
        {movies && movies.map(movie => <p key={movie.id}>{movie.title}</p>)}
      </Grid>
    </>
  )
}
`}</MDXTag></MDXTag>
           </MDXTag>
  }
}
  